import {observable, action, computed, useStrict} from "mobx";
import config from 'config/Config';
import Serv from './SiderBarServ';
const CDN_BASE = "assets";
useStrict(true);
class SiderBarMod{

 @observable
 loading = true;

 @action getMenuList = async (payload) => {
    // 请求参数
    let params = payload;
    // 异步请求方法
    return await Serv.getMenuList(params);
  }
}

// ES6单例写法
export default new SiderBarMod


// WEBPACK FOOTER //
// ./src/widget/SiderBar/SiderBarMod.js